export const GET_REBATES_SYNC_REQ = "GET_REBATES_SYNC_REQ"
export const GET_REBATES_SYNC_SUC = "GET_REBATES_SYNC_SUC"
export const GET_CLASS_SYNC_REQ = "GET_CLASS_SYNC_REQ"
export const GET_CLASS_SYNC_SUC = "GET_CLASS_SYNC_SUC"
// export const GET_SYNC_REQ = "GET_SYNC_REQ"
// export const GET_SYNC_SUC = "GET_SYNC_SUC"